module.exports = __webpack_public_path__ + "static/media/img1-2.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/nutricheck_foliar/N/img1-2.png
// module id = 2445
// module chunks = 3